import React from 'react'
import EditSelect from '../../crm/shared/field_inputs/select/EditSelect';
import { bookingStatusOptions, getOptionsObjectValue } from '../shared/translations'

export default function BookingStatusDropdown({ onChange, value, numberOfConfirmedBookings, maxNumberOfBookings }) {
  const optionValue = getOptionsObjectValue(bookingStatusOptions, value);

    const filteredOptions = () => {
        const reserveBooking = bookingStatusOptions.Reserve.value === optionValue?.value;
        const openConfirmedSpots = (numberOfConfirmedBookings < maxNumberOfBookings);

        if (reserveBooking && openConfirmedSpots) {
            return [bookingStatusOptions.Confirmed];
        } else {
            return [bookingStatusOptions.Confirmed,
            bookingStatusOptions.Reserve,
            bookingStatusOptions.Cancelled,
            bookingStatusOptions.Finished,
            bookingStatusOptions.Absent,
            bookingStatusOptions.Certified,
            bookingStatusOptions.ExternalCertified,
            bookingStatusOptions.TraineeCertified,
            bookingStatusOptions.RetroactiveCertified];
        }
    };

  return (
    <EditSelect
      isExl={true}
      options={filteredOptions()}
      value={optionValue}
      setValue={onChange}
    />
  )
}
